import React from 'react';
import { useParams } from 'react-router-dom';
import NewGptAssistant from './NewGptAssistant';

const EditGptAssistant = () => {
  const { assistantId } = useParams();
  return <NewGptAssistant editAssistantId={assistantId} />;
};

export default EditGptAssistant;
